import { render, staticRenderFns } from "./NeighborhoodComponent.vue?vue&type=template&id=dc2b9724&scoped=true&"
import script from "./NeighborhoodComponent.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodComponent.vue?vue&type=script&lang=js&"
import style0 from "./NeighborhoodComponent.vue?vue&type=style&index=0&id=dc2b9724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2b9724",
  null
  
)

export default component.exports